import { Action } from '@ngrx/store';

import { Screening, ResultItem } from 'modules/shared/models/screening.models';

import {
  SearchSpecificPayload, SearchPayload,
  SearchValidityPayload, SearchValidityResponse, PostScreeningRequest, BatchUpdateSearchResultPayload
} from 'store/models/screening.models';

export enum SearchActionTypes {
  GET_SCREENING = 'GET SCREENING',
  GET_SCREENING_SUCCESS = 'GET SCREENING SUCCESS',
  GET_SCREENING_FAILED = 'GET SCREENING FAILED',
  POST_SCREENING = 'POST SCREENING',
  POST_SCREENING_SUCCESS = 'POST SCREENING SUCCESS',
  POST_SCREENING_FAILED = 'POST SCREENING FAILED',
  GET_SPECIFIC_SCREENING = 'GET SPECIFIC SCREENING',
  GET_SPECIFIC_SCREENING_SUCCESS = 'GET SPECIFIC SCREENING SUCCESS',
  GET_SPECIFIC_SCREENING_FAILED = 'GET SPECIFIC SCREENING FAILED',
  PATCH_SEARCH_RESULT = 'PATCH SEARCH RESULT',
  PATCH_SEARCH_RESULT_SUCCESS = 'PATCH SEARCH RESULT SUCCESS',
  PATCH_SEARCH_RESULT_FAILED = 'PATCH SEARCH RESULT FAILED',
  GET_SEARCH_VALIDITY = 'GET_SEARCH_VALIDITY',
  GET_SEARCH_VALIDITY_SUCCESS = 'GET_SEARCH_VALIDITY_SUCCESS',
  GET_SEARCH_VALIDITY_FAILURE = 'GET_SEARCH_VALIDITY_FAILURE'
}
// Patch search result
export class PatchSearchResult implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.PATCH_SEARCH_RESULT;
  constructor(public payload?: BatchUpdateSearchResultPayload) { }
}
export class PatchSearchResultSuccess implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.PATCH_SEARCH_RESULT_SUCCESS;
  constructor(public payload: ResultItem = null) { }
}
export class PatchSearchResultFailed implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.PATCH_SEARCH_RESULT_FAILED;
  constructor(public payload?: any) { }
}
// Screenings
export class GetScreening implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SCREENING;
  constructor(public payload: SearchPayload = null) { }
}
export class GetScreeningSuccess implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SCREENING_SUCCESS;
  constructor(public payload: Screening = null) { }
}
export class GetScreeningFailed implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SCREENING_FAILED;
  constructor(public payload: any = null) { }
}
export class PostScreening implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.POST_SCREENING;
  constructor(public payload: PostScreeningRequest = null) { }
}
export class PostScreeningSuccess implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.POST_SCREENING_SUCCESS;
  constructor(public payload: any = null) { }
}
export class PostScreeningFailed implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.POST_SCREENING_FAILED;
  constructor(public payload: any = null) { }
}
// Screening by type
export class GetSpecificScreening implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SPECIFIC_SCREENING;
  constructor(public payload: SearchSpecificPayload = null) { }
}
export class GetSpecificScreeningSuccess implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SPECIFIC_SCREENING_SUCCESS;
  constructor(public payload: Screening = null) { }
}
export class GetSpecificScreeningFailed implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SPECIFIC_SCREENING_FAILED;
  constructor(public payload: any = null) { }
}
// Check if searches are valid
export class GetSearchValidity implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SEARCH_VALIDITY;
  constructor(public payload: SearchValidityPayload = null) { }
}
export class GetSearchValiditySuccess implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SEARCH_VALIDITY_SUCCESS;
  constructor(public payload: SearchValidityResponse = null) { }
}
export class GetSearchValidityFailure implements Action {
  readonly type: SearchActionTypes = SearchActionTypes.GET_SEARCH_VALIDITY_FAILURE;
  constructor(public payload: any = null) { }
}
// All type actions
export type SearchActions = GetScreening
  | GetScreeningSuccess
  | GetScreeningFailed
  | GetSpecificScreening
  | GetSpecificScreeningFailed
  | GetSpecificScreeningSuccess
  | PatchSearchResult
  | PatchSearchResultSuccess
  | PatchSearchResultFailed
  | GetSearchValidity
  | GetSearchValiditySuccess
  | GetSearchValidityFailure
  | PostScreening
  | PostScreeningFailed
  | PostScreeningSuccess;

